// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-settings-section {
  padding: 2rem;
  background: #f4f6f8;
  color: #334155;
}
.alert-settings-section .alert-settings-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 2rem;
  text-align: center;
}

.settings-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
}

.settings-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e0e0e0;
}
.settings-card .card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #004A9A;
  margin-bottom: 1.2rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f1f1;
}
.settings-card .card-description {
  font-size: 0.9rem;
  color: #64748b;
  margin-bottom: 1rem;
  font-style: italic;
}

.form-group {
  margin-bottom: 1.5rem;
}
.form-group label {
  display: block;
  font-weight: 500;
  color: #475569;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}
.form-group .form-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #334155;
  transition: all 0.3s ease;
  background-color: white;
}
.form-group .form-input:focus {
  outline: none;
  border-color: #004A9A;
  box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);
}
.form-group .form-input::placeholder {
  color: #94a3b8;
}
.form-group .form-input.masked-input {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
  font-family: "Courier New", monospace;
  letter-spacing: 0.05rem;
}
.form-group .form-input.masked-input:focus {
  border-color: #d1d5db;
  box-shadow: none;
}

.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #f8fafc;
  border-radius: 8px;
}
.toggle-row .toggle-label-wrapper {
  flex: 1 1;
}
.toggle-row .toggle-label-wrapper label {
  font-weight: 500;
  color: #475569;
  font-size: 0.95rem;
  margin-bottom: 0.3rem;
  display: block;
}
.toggle-row .toggle-label-wrapper .helper-text {
  margin: 0.5rem 0 0 0;
  font-size: 0.85rem;
  color: #f59e0b;
  max-width: 600px;
  line-height: 1.4;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.modules-grid .module-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}
.modules-grid .module-item:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
}
.modules-grid .module-item label {
  font-weight: 500;
  color: #475569;
  font-size: 0.9rem;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
  flex-shrink: 0;
}
.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-switch input:checked + .toggle-slider {
  background-color: #004A9A;
}
.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(24px);
}
.toggle-switch input:disabled + .toggle-slider {
  background-color: #d1d5db;
  cursor: not-allowed;
  opacity: 0.6;
}
.toggle-switch .toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbd5e1;
  transition: 0.3s;
  border-radius: 26px;
}
.toggle-switch .toggle-slider.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.toggle-switch .toggle-slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.no-rights-message {
  text-align: center;
  color: #64748b;
  font-size: 0.95rem;
  padding: 2rem;
  font-style: italic;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}
.action-buttons button {
  padding: 0.75rem 2rem;
  font-size: 0.95rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}
.action-buttons button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.action-buttons .cancel-btn {
  background-color: #e5e7eb;
  color: #6b7280;
}
.action-buttons .cancel-btn:hover:not(:disabled) {
  background-color: #d1d5db;
}
.action-buttons .save-btn {
  background-color: #004A9A;
  color: white;
}
.action-buttons .save-btn:hover:not(:disabled) {
  background-color: #003d7a;
  box-shadow: 0 4px 12px rgba(0, 74, 154, 0.3);
}

@media (max-width: 768px) {
  .alert-settings-section {
    padding: 1rem;
  }
  .settings-card {
    padding: 1rem;
  }
  .modules-grid {
    grid-template-columns: 1fr;
  }
  .toggle-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .toggle-row .toggle-label-wrapper {
    width: 100%;
  }
  .action-buttons {
    flex-direction: column;
  }
  .action-buttons button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/GlobalSettingsPage/AlertSettings/AlertSettings.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAAF;AAEE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CAAA;EACA,yBAAA;AADF;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,gCAAA;AADJ;AAIE;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,qBAAA;AAHF;AAKE;EACE,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AAHJ;AAME;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;AAJJ;AAMI;EACE,aAAA;EACA,qBAAA;EACA,2CAAA;AAJN;AAOI;EACE,cAAA;AALN;AAQI;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,qCAAA;EACA,uBAAA;AANN;AAQM;EACE,qBAAA;EACA,gBAAA;AANR;;AAYA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AATF;AAWE;EACE,SAAA;AATJ;AAWI;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AATN;AAYI;EACE,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAVN;;AAeA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,gBAAA;AAZF;AAcE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAZJ;AAcI;EACE,yBAAA;EACA,qBAAA;AAZN;AAeI;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;AAbN;;AAkBA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAfF;AAiBE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AAfJ;AAiBI;EACE,yBAAA;AAfN;AAkBI;EACE,2BAAA;AAhBN;AAmBI;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAjBN;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,mBAAA;EACA,YAAA;AAnBN;AAsBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;AApBN;;AAyBA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAtBF;AAwBE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAtBJ;AAwBI;EACE,YAAA;EACA,mBAAA;AAtBN;AA0BE;EACE,yBAAA;EACA,cAAA;AAxBJ;AA0BI;EACE,yBAAA;AAxBN;AA4BE;EACE,yBAAA;EACA,YAAA;AA1BJ;AA4BI;EACE,yBAAA;EACA,4CAAA;AA1BN;;AAgCA;EACE;IACE,aAAA;EA7BF;EAgCA;IACE,aAAA;EA9BF;EAiCA;IACE,0BAAA;EA/BF;EAkCA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAhCF;EAkCE;IACE,WAAA;EAhCJ;EAoCA;IACE,sBAAA;EAlCF;EAoCE;IACE,WAAA;EAlCJ;AACF","sourcesContent":["// AlertSettings.scss\r\n.alert-settings-section {\r\n  padding: 2rem;\r\n  background: #f4f6f8;\r\n  color: #334155;\r\n  \r\n  .alert-settings-title {\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 2rem;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n.settings-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.settings-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n  border: 1px solid #e0e0e0;\r\n  \r\n  .card-title {\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    color: #004A9A;\r\n    margin-bottom: 1.2rem;\r\n    padding-bottom: 0.5rem;\r\n    border-bottom: 1px solid #f1f1f1;\r\n  }\r\n\r\n  .card-description {\r\n    font-size: 0.9rem;\r\n    color: #64748b;\r\n    margin-bottom: 1rem;\r\n    font-style: italic;\r\n  }\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1.5rem;\r\n\r\n  label {\r\n    display: block;\r\n    font-weight: 500;\r\n    color: #475569;\r\n    margin-bottom: 0.5rem;\r\n    font-size: 0.95rem;\r\n  }\r\n\r\n  .form-input {\r\n    width: 100%;\r\n    padding: 0.75rem;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 8px;\r\n    font-size: 0.95rem;\r\n    color: #334155;\r\n    transition: all 0.3s ease;\r\n    background-color: white;\r\n\r\n    &:focus {\r\n      outline: none;\r\n      border-color: #004A9A;\r\n      box-shadow: 0 0 0 3px rgba(0, 74, 154, 0.1);\r\n    }\r\n\r\n    &::placeholder {\r\n      color: #94a3b8;\r\n    }\r\n\r\n    &.masked-input {\r\n      background-color: #f9fafb;\r\n      color: #6b7280;\r\n      cursor: not-allowed;\r\n      font-family: 'Courier New', monospace;\r\n      letter-spacing: 0.05rem;\r\n      \r\n      &:focus {\r\n        border-color: #d1d5db;\r\n        box-shadow: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.toggle-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 1rem;\r\n  padding: 1rem;\r\n  background-color: #f8fafc;\r\n  border-radius: 8px;\r\n  \r\n  .toggle-label-wrapper {\r\n    flex: 1;\r\n\r\n    label {\r\n      font-weight: 500;\r\n      color: #475569;\r\n      font-size: 0.95rem;\r\n      margin-bottom: 0.3rem;\r\n      display: block;\r\n    }\r\n\r\n    .helper-text {\r\n      margin: 0.5rem 0 0 0;\r\n      font-size: 0.85rem;\r\n      color: #f59e0b;\r\n      max-width: 600px;\r\n      line-height: 1.4;\r\n    }\r\n  }\r\n}\r\n\r\n.modules-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: 1rem;\r\n  margin-top: 1rem;\r\n\r\n  .module-item {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0.75rem 1rem;\r\n    background-color: #f8fafc;\r\n    border-radius: 8px;\r\n    border: 1px solid #e2e8f0;\r\n    transition: all 0.3s ease;\r\n\r\n    &:hover {\r\n      background-color: #f1f5f9;\r\n      border-color: #cbd5e1;\r\n    }\r\n\r\n    label {\r\n      font-weight: 500;\r\n      color: #475569;\r\n      font-size: 0.9rem;\r\n    }\r\n  }\r\n}\r\n\r\n.toggle-switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 50px;\r\n  height: 26px;\r\n  flex-shrink: 0;\r\n\r\n  input {\r\n    opacity: 0;\r\n    width: 0;\r\n    height: 0;\r\n\r\n    &:checked + .toggle-slider {\r\n      background-color: #004A9A;\r\n    }\r\n\r\n    &:checked + .toggle-slider:before {\r\n      transform: translateX(24px);\r\n    }\r\n\r\n    &:disabled + .toggle-slider {\r\n      background-color: #d1d5db;\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n  }\r\n\r\n  .toggle-slider {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: #cbd5e1;\r\n    transition: 0.3s;\r\n    border-radius: 26px;\r\n\r\n    &.disabled {\r\n      cursor: not-allowed;\r\n      opacity: 0.6;\r\n    }\r\n\r\n    &:before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 20px;\r\n      width: 20px;\r\n      left: 3px;\r\n      bottom: 3px;\r\n      background-color: white;\r\n      transition: 0.3s;\r\n      border-radius: 50%;\r\n      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    }\r\n  }\r\n}\r\n\r\n.no-rights-message {\r\n  text-align: center;\r\n  color: #64748b;\r\n  font-size: 0.95rem;\r\n  padding: 2rem;\r\n  font-style: italic;\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n  max-width: 1000px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n\r\n  button {\r\n    padding: 0.75rem 2rem;\r\n    font-size: 0.95rem;\r\n    font-weight: 600;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    min-width: 150px;\r\n\r\n    &:disabled {\r\n      opacity: 0.6;\r\n      cursor: not-allowed;\r\n    }\r\n  }\r\n\r\n  .cancel-btn {\r\n    background-color: #e5e7eb;\r\n    color: #6b7280;\r\n\r\n    &:hover:not(:disabled) {\r\n      background-color: #d1d5db;\r\n    }\r\n  }\r\n\r\n  .save-btn {\r\n    background-color: #004A9A;\r\n    color: white;\r\n\r\n    &:hover:not(:disabled) {\r\n      background-color: #003d7a;\r\n      box-shadow: 0 4px 12px rgba(0, 74, 154, 0.3);\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 768px) {\r\n  .alert-settings-section {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .settings-card {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .modules-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .toggle-row {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 1rem;\r\n\r\n    .toggle-label-wrapper {\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  .action-buttons {\r\n    flex-direction: column;\r\n    \r\n    button {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
